<template>
  <div v-if="text" @click="$emit('click', $event)">
    <div v-if="text.length <= length">
      {{ text }}
    </div>
    <v-tooltip bottom max-width="50%" v-else>
      <template v-slot:activator="{ on }">
        <div v-on="on">
          {{ text | truncate(length) }}
        </div>
      </template>
      <span>
        {{ text }}
      </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'TruncateTextWithHover',
  props: {
    /**
     * Text displayed.
     */
    text: {
      type: String,
      required: false,
    },
    /**
     * Maximum length of text.
     * If text's length exceed this number, it will be truncated and shown with a hover.
     */
    length: {
      type: Number,
      required: true,
    },
  },
  filters: {
    truncate(text, length) {
      return text.slice(0, length).concat('...');
    },
  },
};
</script>
